import { Base64 } from 'js-base64';
import { SupportCenterRepository } from '../../domains/support-center/SupportCenterRepository.js';
import { Archiving } from './archive/Archiving.js';
import { Billing } from './billing/Billing.js';
import { Clients } from './clients/Clients.js';
import { CustomsInvoicesRepository } from '../../domains/customs/CustomsInvoicesRepository.js';
import { DraftCustomsInvoicesRepository } from '../../domains/customs/DraftCustomsInvoicesRepository.js';
import { DropOffs } from './dropoffs/DropOffs.js';
import { Invoices } from './invoices/Invoices.js';
import { Locations } from './locations/Locations.js';
import { Onboarding } from './onboarding/Onboarding.js';
import { Parcels } from './parcels/Parcels.js';
import { Shipments } from './shipments/Shipments.js';
import { ShipmentsNotifications } from './notifications/shipments/Shipments.js';
import { Users } from './users/Users.js';
import { TrackingRepository } from '../../domains/tracking/TrackingRepository.js';
import { VolumeDiscountRepository } from './volume-discount/VolumeDiscountRepository.js';
import { Vouchers } from './vouchers/Vouchers.js';
import { Zendesk } from './zendesk/Zendesk.js';
import { OrderRepository } from './orders/OrderRepository.js';
import { Debug } from './debug/Debug.js';
import { ServiceRepository } from '../../domains/service/ServiceRepository.js';

class V1 {
  /** @deprecated import CustomsInvoicesRepository instead */

  /** @deprecated import DraftCustomsInvoicesRepository instead */

  /** @deprecated import either CountriesRepository, PostalCodesRepository, or PostalZonesRepository instead */

  /** @deprecated import ServiceRepository instead */

  /** @deprecated import TrackingRepository instead */

  /** @deprecated import OrderRepository instead */

  /** @deprecated import SupportCenterRepository instead  */

  constructor(apiClient) {
    this.apiClient = apiClient;
    this.archive = new Archiving(apiClient);
    this.billing = new Billing(apiClient);
    this.clients = new Clients(apiClient);
    this.customsInvoices = new CustomsInvoicesRepository(apiClient);
    this.draftCustomsInvoices = new DraftCustomsInvoicesRepository(apiClient);
    this.dropOffs = new DropOffs(apiClient);
    this.invoices = new Invoices(apiClient);
    this.locations = new Locations(apiClient);
    this.onboarding = new Onboarding(apiClient);
    this.parcels = new Parcels(apiClient);
    this.services = new ServiceRepository(apiClient);
    this.shipments = new Shipments(apiClient);
    this.shipmentsNotifications = new ShipmentsNotifications(apiClient);
    this.users = new Users(apiClient);
    this.tracking = new TrackingRepository(apiClient);
    this.volumeDiscount = new VolumeDiscountRepository(apiClient);
    this.vouchers = new Vouchers(apiClient);
    this.zendesk = new Zendesk(apiClient);
    this.orders = new OrderRepository(apiClient);
    this.supportCenter = new SupportCenterRepository(apiClient);
    this.debug = new Debug(apiClient);
  }
  login(username, password) {
    return this.apiClient.get('v1/login', {
      ...this.apiClient.withRequestContext()
    }, {
      Authorization: `Basic ${Base64.encode(`${username}:${password}`)}`
    }).then(response => response.data);
  }
  logout() {
    return this.apiClient.delete('v1/logout');
  }
  register(ecommerces, email, estimatedDeliveryVolume, language, marketplaces, password, phone, policies, source, referral) {
    var _this$apiClient$getTe;
    const tenantId = (_this$apiClient$getTe = this.apiClient.getTenant()) === null || _this$apiClient$getTe === void 0 ? void 0 : _this$apiClient$getTe.name;
    if (!tenantId) {
      throw new Error('The user not has a tenant associated, you need to specify a tenant in the api client');
    }
    return this.apiClient.post(`v1/register`, {
      ecommerces,
      email,
      estimated_delivery_volume: estimatedDeliveryVolume,
      language,
      marketplaces,
      password,
      phone,
      policies,
      referral,
      source,
      ...this.apiClient.withRequestContext(),
      tenant_id: tenantId
    }).then(response => {
      return {
        token: response.data.token,
        userId: response.data.user_id
      };
    });
  }

  // this endpoint will be removed from the SDK when the migration from Kokudo to PRO had finished
  migrate(username, password) {
    const {
      platform_country
    } = this.apiClient.withRequestContext();
    return this.apiClient.post(`v1/migrate`, {}, {
      platformCountry: platform_country
    }, {
      Authorization: `Basic ${Base64.encode(`${username}:${password}`)}`
    }).then(response => response.data);
  }
}

export { V1 };
//# sourceMappingURL=V1.js.map
